(() => {
  const close = (details, focus = false) => {
    details.open = false;
    const summary = details.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
    if (focus) summary?.focus();
  };
  const menus = () => [...document.querySelectorAll('[data-lb-nav]')];
  function init(scope = document) {
    scope.querySelectorAll('[data-lb-nav]').forEach(details => {
      if (details.dataset.ready) return;
      details.dataset.ready = 'true';
      details.addEventListener('toggle', () => {
        details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
        if (details.open) menus().filter(other => other !== details).forEach(other => close(other));
      });
      details.querySelector('[data-lb-nav-close]')?.addEventListener('click', () => close(details, true));
    });
    const field = scope.querySelector('textarea[data-lb-advice-prefix]');
    if (!field || field.dataset.prefilled || field.value.trim()) return;
    const params = new URLSearchParams(location.search);
    const product = params.get('product')?.slice(0, 250);
    if (!product) return;
    const lines = [field.dataset.lbAdvicePrefix, product];
    const variant = params.get('variant')?.slice(0, 250);
    if (variant) lines.push(`${field.dataset.lbVariantLabel} : ${variant}`);
    const uses = {fr: {dj:'DJ et événements',venue:'Bar ou salle',stage:'Scène et spectacle',installation:'Installation permanente'},en:{dj:'DJ and events',venue:'Bar or venue',stage:'Stage and performance',installation:'Permanent installation'}};
    const use = uses[document.documentElement.lang.startsWith('en') ? 'en' : 'fr'][params.get('use')];
    if (use) lines.push(`${field.dataset.lbUseLabel} : ${use}`);
    const productPath = params.get('product_url');
    if (productPath && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^?#\s]+$/i.test(productPath)) lines.push(new URL(productPath, location.origin).href);
    field.value = lines.join('\n') + '\n\n';
    field.dataset.prefilled = 'true';
    const service = scope.querySelector('[data-lb-service-select]');
    if (service && !service.value) service.value = 'vente';
  }
  document.addEventListener('click', event => {
    const sameLink = event.target.closest('a[href]');
    if (sameLink && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !sameLink.hasAttribute('download') && (!sameLink.target || sameLink.target === '_self')) {
      const destination = new URL(sameLink.href, location.href);
      if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search && !destination.hash) {
        event.preventDefault();
        menus().filter(details => details.open).forEach(details => close(details));
        const drawer = sameLink.closest('menu-drawer,header-drawer');
        if (drawer?.closeMenuDrawer) drawer.closeMenuDrawer(event);
        if (location.hash) history.replaceState(history.state, '', destination.pathname + destination.search);
        window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        return;
      }
    }
    const link = event.target.closest('[data-lb-advice-link]');
    if (link) {
      const advice = link.closest('[data-lb-advice]');
      const url = new URL(link.href, location.origin);
      const use = advice.querySelector('[data-lb-advice-use]')?.value;
      if (use) url.searchParams.set('use', use); else url.searchParams.delete('use');
      const info = advice.closest('product-info');
      const options = [...(info?.querySelectorAll('variant-selects fieldset input:checked, variant-selects select option:checked') || [])].map(option => option.tagName === 'OPTION' ? option.textContent.trim() : option.value);
      if (options.length) url.searchParams.set('variant', options.join(' / ')); else url.searchParams.delete('variant');
      link.href = url.href;
    }
    menus().filter(details => details.open && !details.contains(event.target)).forEach(details => close(details));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') menus().filter(details => details.open).forEach(details => close(details, true));
  });
  document.addEventListener('focusin', event => menus().filter(details => details.open && !details.contains(event.target)).forEach(details => close(details)));
  matchMedia('(max-width:989px)').addEventListener('change', event => {if (event.matches) menus().forEach(details => close(details));});
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
